// TODO: hook name without "use" — named like the other fetch-* hooks of the top search panel
import { useMemo } from 'react';

import { httpMethods } from 'utils/hooks/use-fetch-data';
import * as endpoints from 'utils/api/endpoints';
import { normalizeScoutPlayerProfile } from 'utils/helpers/player-profile-utils';
import { useUniversalFetchData } from 'utils/hooks/use-universal-fetch-data';

export const useFetchScoutPlayerProfiles = (playerIds = []) => {
    const ids = useMemo(
        () => [...new Set((playerIds || []).map(id => Number(id)).filter(id => Number.isFinite(id) && id > 0))],
        [playerIds]
    );

    const requests = useMemo(
        () =>
            ids.map(playerId => ({
                method: httpMethods.get,
                url: endpoints.playerProfile,
                params: { playerId },
                enableCache: true
            })),
        [ids]
    );

    const { data: profileResponses = [], processing } = useUniversalFetchData(
        ids.length ? requests : { url: '', initialCondition: false, isDisabled: true }
    );

    const profiles = useMemo(() => {
        const list = Array.isArray(profileResponses) ? profileResponses : profileResponses ? [profileResponses] : [];

        return list.map(normalizeScoutPlayerProfile).filter(Boolean);
    }, [profileResponses]);

    const profilesById = useMemo(() => Object.fromEntries(profiles.map(profile => [String(profile.id), profile])), [
        profiles
    ]);

    const orderedProfiles = useMemo(() => ids.map(id => profilesById[String(id)]).filter(Boolean), [ids, profilesById]);

    return { profiles, orderedProfiles, profilesById, processing: ids.length ? processing : false };
};
